import { PipelineAPI } from '../../pipelines/api/PipelineAPI';
import { Recipient } from '../ManageRecipients/interface';
import { NotificationsAPI } from '../NotificationsAPI';
import { RawPreferencesFactory } from '../Preferences/Factory';
import { Preference } from '../Preferences/Interface';
import { getRawDataForSelectedPipelines } from '../Subscriptions/Utils';

export class RecipientAlertService {
  recipient: Recipient | null = null;

  setRecipient(recipient: Recipient) {
    this.recipient = recipient;
  }

  getSubscriptions() {
    return Promise.all([
      PipelineAPI.getIntegrations(),
      NotificationsAPI.getRecipientSubscribedPipelinesList(this.recipient!.id)
    ]);
  }

  unSubscribePipelines(items: Set<string | number>) {
    return NotificationsAPI.unSubscribePipelinesForRecipient(
      getRawDataForSelectedPipelines(items),
      this.recipient!.id
    );
  }

  subscribePipelines(items: Set<string | number>) {
    return NotificationsAPI.subscribePipelinesForRecipient(
      getRawDataForSelectedPipelines(items),
      this.recipient!.id
    );
  }

  getPreferences() {
    return NotificationsAPI.getPreferencesForRecipient(this.recipient!.id);
  }

  getUserPreferencesMetaData() {
    return NotificationsAPI.getUserPreferencesMetaData();
  }

  savePreferences(preferences: Preference[]) {
    return NotificationsAPI.savePreferencesForRecipient(
      RawPreferencesFactory(preferences),
      this.recipient!.id
    );
  }
}
